module.exports = __webpack_public_path__ + "assets/shoe.de23a447.svg";